import { render, staticRenderFns } from "./sz.vue?vue&type=template&id=2698351d&scoped=true"
import script from "./sz.vue?vue&type=script&lang=js"
export * from "./sz.vue?vue&type=script&lang=js"
import style0 from "./sz.vue?vue&type=style&index=0&id=2698351d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698351d",
  null
  
)

export default component.exports